import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

interface PropTypes {
  label: string;
  options: string[] | undefined;
  value: string;
  onChange: (data: string) => void;
}
const DropDown = (props: PropTypes) => {
  const { label, options, value, onChange } = props;
  const handleChange = (event: SelectChangeEvent) => {
    const selectedOption = event.target.value as string;
    onChange(selectedOption);
  };
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label"> {label} </InputLabel>
      <Select
        id="demo-simple-select"
        label={label}
        value={value}
        onChange={handleChange}
      >
        {options?.map((menuItem: string) => {
          return (
            <MenuItem key={menuItem} value={menuItem}>
              {menuItem}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default DropDown;
